import React, { FC } from 'react';
import { useTeamStatusesQuery } from '../api';
import { Select } from '../components/Inputs';
import { ControllerProps } from 'react-hook-form/dist/types/props';

interface TeamStatus extends Pick<ControllerProps<'input'>, 'control' | 'name' | 'rules'> {
  label: string;
  error: boolean | undefined;
}

const TeamStatus: FC<TeamStatus> = ({ label, error, control, name, rules }) => {
  const { data } = useTeamStatusesQuery();
  return (
    <Select
      label={label}
      data={(data && data.dirNationalTeamStatuses) || []}
      control={control}
      error={error}
      name={name}
      rules={rules}
    />
  );
};

export default TeamStatus;
